<div class="example-pizza-party">{{data}} <span class="example-spacer" ></span><span>‼‼</span></div>